/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Errormessage1Inputs */

const en_entity_errormessage1 = /** @type {(inputs: Entity_Errormessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error Message`)
};

const de_entity_errormessage1 = /** @type {(inputs: Entity_Errormessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlermeldung`)
};

/**
* | output |
* | --- |
* | "Error Message" |
*
* @param {Entity_Errormessage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_errormessage1 = /** @type {((inputs?: Entity_Errormessage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Errormessage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_errormessage1(inputs)
	return de_entity_errormessage1(inputs)
});
export { entity_errormessage1 as "entity_errorMessage" }